// ColorBox.jsx
import React from 'react';

const ColorBox = ({ color }) => {
    const boxStyle = {
        display: 'inline-block',
        width: '16px',
        height: '16px',
        backgroundColor: color,
        border: '1px solid black',
        marginRight: '8px',
    };

    return <span style={boxStyle}></span>;
};

export default ColorBox;
